import About from '/components/about';
import { Image, Card, Link } from 'theme-ui';
import * as React from 'react';
export default {
  About,
  Image,
  Card,
  Link,
  React
};